import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  public static BackButtonClickedCb = () => {
    // push current state again to prevent further attempts.
    history.pushState(null, '', location.href);
  };
  private menuSubject = new BehaviorSubject<boolean>(true);
  private optionsSubject = new BehaviorSubject<boolean>(true);
  private backButtonSubject = new BehaviorSubject<boolean>(true);
  private subscription: Subscription = new Subscription;
  public backButtonClicked = false;
  public onBackButtonClicked = NavigationService.BackButtonClickedCb;
  backButtonAction?: () => void;

  get menu$() {
    return this.menuSubject.asObservable();
  }

  get options$() {
    return this.optionsSubject.asObservable();
  }

  get backButton$() {
    return this.backButtonSubject.asObservable();
  }

  setBackButtonClicked(backButtonClicked: boolean) {
    this.backButtonClicked = backButtonClicked;
  }

  subscribeBackButtonEvent(onBackButtonClicked:any = undefined) {
    this.onBackButtonClicked = onBackButtonClicked == undefined ? NavigationService.BackButtonClickedCb : onBackButtonClicked;
    this.subscription = fromEvent(window, 'popstate').subscribe(() => {
      this.backButtonClicked = true;
    });
  }

  unsubscribeBackButtonEvent() {
    this.subscription.unsubscribe();
  }

  showMenu() {
    this.menuSubject.next(true);
  }

  hideMenu() {
    this.menuSubject.next(false);
  }

  showOptions() {
    this.optionsSubject.next(true);
  }

  hideOptions() {
    this.optionsSubject.next(false);
  }

  showBackButton() {
    this.backButtonSubject.next(true);
  }

  hideBackButton() {
    this.backButtonSubject.next(false);
    this.setBackButtonClicked(false);
  }

  showBackButtonAndUnsubscribe() {
    this.showBackButton();
    this.unsubscribeBackButtonEvent();
  }

  hideBackButtonAndSubscribe(onBackButtonClicked:any = undefined) {
    this.hideBackButton()
    this.subscribeBackButtonEvent(onBackButtonClicked);
  }

  addBackButtonAction(action: () => void): void {
    this.backButtonAction = action;
  }

  removeBackButtonAction(): void {
    this.backButtonAction = undefined;
  }
}
